import { SAMPLE_TYPES_ACTIONS } from "constants/Actions/SampleTypes";

// Estado inicial del reducer
const aInitialState = {
    aTypes: [],
    aTypesList: [],
    oType: null,
    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los tipos de mustras soportados por el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const SampleReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case SAMPLE_TYPES_ACTIONS.GET:
            return { ...aState, aTypes: oAction.data };
        case SAMPLE_TYPES_ACTIONS.GET_LIST:
            return { ...aState, aTypesList: oAction.data };
        case SAMPLE_TYPES_ACTIONS.GET_SAMPLE_TYPE_LIST_BY_CLINICAL_ANALYSIS_TYPE:
            return { ...aState, aTypesList: oAction.data.data };
        case SAMPLE_TYPES_ACTIONS.GET_SAMPLE_TYPE_LIST_BY_PATERNITY_STUDY_TYPE:
            return { ...aState, aTypesList: oAction.data.data };
        case SAMPLE_TYPES_ACTIONS.CLEAN:
            return { ...aState, aTypes: [], aTypesList: [], bIsSuccess: false, bIsError: false, oType: null };
        case SAMPLE_TYPES_ACTIONS.FIND:
            return { ...aState, oType: oAction.data };
        case SAMPLE_TYPES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case SAMPLE_TYPES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        default:
            return aState;
    }
}
